export default __webpack_public_path__ + "static/media/SourceSerifPro-Regular.6f22301c.ttf";